import jwt_decode from 'jwt-decode'
import useScopes, { IdoniaScope, zero } from './scopes'
const {
  parseScopeCollection,
  hasAll: scopeHasAll,
  hasAny: scopeHasAny,
  hasScope: scopeHasScope,
  has: scopeHas
} = useScopes()
export const EMPTY_SCOPE_COLLECTION = {
  scopeMask: zero,
  arguments: null,
  isScoped: false
}
export const IDONIA_SCOPE_COLLECTION = {
  scopeMask: IdoniaScope,
  arguments: null,
  isScoped: false
}

export default function useTokenScopesUtil () {
  let scopes = Object.assign({}, EMPTY_SCOPE_COLLECTION)
  function setScopeCollection (scopeCollection) {
    scopes = scopeCollection
    scopes.isScoped = isScoped()
    return scopes
  }
  function getScopes (idToken, decodedToken) {
    let tokenData = decodedToken

    if (!tokenData) {
      try {
        tokenData = jwt_decode(idToken)
      } catch (e) {
        console.error(e)
      }
    }

    if (tokenData && tokenData['idonia.scope']) {
      scopes = parseScopeCollection(tokenData['idonia.scope'])
    }
    scopes.isScoped = isScoped()
    return scopes
  }
  function hasAll (scope) {
    return scopeHasAll(scopes, scope)
  }

  function hasAny (scope) {
    return scopeHasAny(scopes, scope)
  }

  function hasScope (scope = {}) {
    return scopeHasScope(scopes, scope)
  }

  function has (scope = 0) {
    return scopeHas(scopes, scope)
  }
  function isScoped () {
    return scopes.scopeMask && !scopeHasAll(scopes, IdoniaScope)
  }
  return {
    setScopeCollection,
    getScopes,
    hasAll,
    hasAny,
    hasScope,
    has,
    isScoped
  }
}



// WEBPACK FOOTER //
// ./src/commons/tokenScopes.js